module.exports = __webpack_public_path__ + "img/twitter1.3a597ec6.svg";